var render = function render(){var _vm=this,_c=_vm._self._c;return _c('sidebar-menu',{staticClass:"iot-sidebar",attrs:{"menu":_vm.menu,"width":"200px","collapsed":true,"hiddenOnCollapse":"true"}},[_c('span',{attrs:{"slot":"dropdown-icon"},slot:"dropdown-icon"},[_c('FontAwesomeIcon',{attrs:{"icon":"chevron-right"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }